<template>
  <router-view v-if="$route.meta.top"></router-view>
  <DefaultInnerTabLayout v-else-if="$route.meta.innerTab"></DefaultInnerTabLayout>
  <DefaultLayout v-else></DefaultLayout>
  <GlobalLoadingOverlay />
</template>

<script lang="ts">
  import DefaultLayout from "@/layouts/DefaultLayout.vue";
  import DefaultInnerTabLayout from "@/layouts/DefaultInnerTabLayout.vue";
  import GlobalLoadingOverlay from "@/components/common/GlobalLoadingOverlay.vue";
  import { defineComponent } from "vue";
  import GlobalPopupProcessor from "@/mixins/GlobalPopupProcessor";
  export default defineComponent({
    name: "App",
    components: {
      DefaultLayout,
      DefaultInnerTabLayout,
      GlobalLoadingOverlay,
    },
    mixins: [GlobalPopupProcessor],
  });
</script>

<style lang="scss">
  @use "/src/assets/styles/common" as *;

  /* App 전체 화면 스타일 */
  #app {
    width: 100% !important;
    height: 100% !important;
    min-height: 100vh !important;
    position: relative !important;
    overflow: visible !important;
  }

  .default-layout {
    width: 100% !important;
    height: 100% !important;
    min-height: 100vh !important;
    position: relative !important;
    overflow: visible !important;
  }
</style>
